import { createEvent, sample } from 'effector'
import { BanRequest, BanRequestData } from './types'
import { fx } from '../../../../libs'

export const banMounted = createEvent<BanRequestData>()

export const banClient = fx<BanRequest, void>({
  method: 'PATCH',
  url: `/promo/anniversary/{typeOfClient}/participant/{clientId}`,
})

sample({
  clock: banMounted,
  fn: ({ banReason, id, typeOfClient }) => {
    return {
      url: `/promo/anniversary/${typeOfClient}/participant/${id}`,
      body: {
        banReason: banReason,
      },
    }
  },
  target: banClient,
})
